import type { GetNotifications200NotificationsItem } from './getNotifications200NotificationsItem';

export type GetNotifications200 = {
  notifications?: GetNotifications200NotificationsItem[];
  unreadCount?: number;
};
